import { useEffect, useState, useRef,useCallback } from 'react';
import { Card, Typography, Tabs, Select, Spin, Table, Input, Button, Switch, Tooltip, Popover } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAllOrganzations } from '../../redux/adminSlice';
import { fetchTrades, fetchServices } from '../../redux/tradeSlice';
import { fetchJobs } from '../../redux/jobsSlice';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import axiosInstance from '../../redux/apiAxios';
import { BarChartOutlined, SearchOutlined, FileExcelOutlined, InteractionOutlined, PaperClipOutlined, CalendarOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import './Adminanalytics.css';
import AnalyticsHeader from './components/AnalyticsHeader';
import AnalyticsTable from './components/AnalyticsTable';
import CombinedAnalysisChart from './components/CombinedAnalysisChart';
import debounce from 'lodash/debounce';
import AnimatedProgressBar from '../UI/animatedProgressBar';
import DetailedAnalysis from '../Analytics/DetailedAnalysis';
import DateRangeFilter from '../UI/DateRangeFilter';
import { adminAnalyticsUsers } from '../../utils/constants';
import { BiAnalyse } from 'react-icons/bi';
import { DateRangePicker } from 'react-date-range';

dayjs.extend(utc);

const { Title } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

export default function Adminanalytics() {
  const { organizationsList, loading } = useSelector((state) => state.admin);
  const { organizationData } = useSelector((state) => state.organization);
  const { trades, services } = useSelector((state) => state.trade);
  const { jobs } = useSelector((state) => state.jobs);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [localSelectedOrgs, setLocalSelectedOrgs] = useState([]);
  const [selectedTradeOrganizations, setSelectedTradeOrganizations] = useState([]);
  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: dayjs().startOf('month').toDate(),
      endDate: dayjs().endOf('month').toDate(),
      key: 'selection',
    },
  ]);
  const [pickerOpen, setPickerOpen] = useState(false);
  const pickerRef = useRef(null);
  const [mergedData, setMergedData] = useState([]);
  const [dateLoading, setDateLoading] = useState(false);
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedMedium, setSelectedMedium] = useState(null);
  const [selectedCustomerType, setSelectedCustomerType] = useState(null);
  const [selectedTrade, setSelectedTrade] = useState(null);
  const [selectedServiceType, setSelectedServiceType] = useState(null);
  const [selectedJobType, setSelectedJobType] = useState(null);
  const [sourceData, setSourceData] = useState([]);
  const [sourceLoading, setSourceLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');
  const [tradeAnalysisData, setTradeAnalysisData] = useState([]);
  const [tradeAnalysisLoading, setTradeAnalysisLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);
  const [activeInnerTab, setActiveInnerTab] = useState('customer_journey');

  const [customerJourneyFilters, setCustomerJourneyFilters] = useState({});
  const [customerJourneySorts, setCustomerJourneySorts] = useState({});
  const [buttonAnalysisFilters, setButtonAnalysisFilters] = useState({});
  const [buttonAnalysisSorts, setButtonAnalysisSorts] = useState({});
  const [pageAnalysisFilters, setPageAnalysisFilters] = useState({});
  const [pageAnalysisSorts, setPageAnalysisSorts] = useState({});
    
  const [leads_sources, setLeadsSources] = useState([]);
  const [lead_medium, setLeadMedium] = useState([]);
  const [lead_campaigns, setLeadCampaigns] = useState([]);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [showUniqueData, setShowUniqueData] = useState(true);
  
  const [customerJourneyData, setCustomerJourneyData] = useState([]);
  const [customerJourneyLoading, setCustomerJourneyLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [contactsDataLoaded, setContactsDataLoaded] = useState(false);
  const [customerJourneyPagination, setCustomerJourneyPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });
  const [tradeAnalysisPagination, setTradeAnalysisPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });
  const [pageAnalysisPagination, setPageAnalysisPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  const [customerJourneyDataView, setCustomerJourneyDataView] = useState('all');
  const [selectedBookingType, setSelectedBookingType] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedDeviceType, setSelectedDeviceType] = useState(null);

  const dispatch = useDispatch();
  const tradeAnalysisAbortController = useRef(null);
  const pageAnalysisAbortController = useRef(null);
  const customerJourneyAbortController = useRef(null);
  const overviewAbortController = useRef(null);
  const sourceAnalysisAbortController = useRef(null);
  const detailedAnalysisRef = useRef(null);

  const {
    isAdmin = false,
    currentOrganizationId,
    currentOrganizationIds,
    user,
  } = useSelector((state) => state?.auth);

  const isExclusiveUser = user?.email && adminAnalyticsUsers.includes(user.email);
  

  const pageOptions = [
    { label: 'Trade Selection', value: 'Trade Selection', step: 1 },
    { label: 'Service Selection', value: 'Service Selection', step: 2 },
    { label: 'Category List', value: 'Category Selection', step: 3 },
    { label: 'Job Selection', value: 'Job Selection', step: 4 },
    { label: 'Diagnostic Fee', value: 'Agree Fee', step: 5 },
    { label: 'Additional Description', value: 'Additional Description',step:6 },
    { label: 'Select Time Slot', value: 'Select Time Slot', step: 7 },
    { label :"Appointment/Review",value:'Appointment/Review',step:8}
  ];


    const debouncedOrgChange = useCallback(
    debounce((values) => {
      setSelectedOrganizations(values);
      setSelectedTradeOrganizations(values);
      if (activeTab === 'overview') {
        fetchOverviewData(values, selectedRange[0], selectedSource, selectedMedium,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
      }
      else if (activeTab === 'analysis') {
                  fetchSourceAnalysisData(values, selectedRange[0], selectedSource, selectedMedium,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
      }
      else if (activeTab === 'trade_analysis') {
        if (activeInnerTab === 'button_based') {
          setTradeAnalysisPagination({ current: 1, pageSize: 10, total: 0 });
          handleTradeAnalysisChange(selectedRange[0], 1, 15, values,selectedSource,selectedMedium,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedDeviceType);
        }
        else if (activeInnerTab === 'page_based') {
          setPageAnalysisPagination({ current: 1, pageSize: 10, total: 0 });
                      handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, values,selectedSource,selectedMedium,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType, selectedDeviceType);
        }
        else if (activeInnerTab === 'customer_journey') {
          setCustomerJourneyPagination({ current: 1, pageSize: 10, total: 0 });
          handleCustomerJourneyChange(selectedRange[0], 1, 10, values,selectedSource,selectedMedium,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType, selectedDeviceType);
        }
      }
      if (values.length === 0) {
        setSourceData([]);
        setMergedData([]);
        setTradeAnalysisData([]);
        setCustomerJourneyData([]);
      }
    }, 500),
    [activeTab, activeInnerTab, selectedRange, selectedSource, selectedMedium, selectedPage,selectedCustomerType, selectedDeviceType]
  );

  useEffect(() => {
    return () => {
      debouncedOrgChange.cancel();
    };
  }, [debouncedOrgChange]);

  const handleLocalOrgChange = useCallback((values) => {
    setLocalSelectedOrgs(values);
    debouncedOrgChange(values);
  }, [debouncedOrgChange]);


  useEffect(() => {
    dispatch(fetchAllOrganzations());
    dispatch(fetchTrades());
    dispatch(fetchServices());
    dispatch(fetchJobs());
  }, [dispatch]);

  useEffect(() => {
    if (organizationsList?.length > 0) {
      const allOrgIds = isAdmin ? organizationsList.map(org => org._id) : currentOrganizationIds;
      setSelectedOrganizations(allOrgIds);
      setLocalSelectedOrgs(allOrgIds);
      setSelectedTradeOrganizations(allOrgIds);
      const initializeData = async () => {
        await Promise.all([
          fetchOverviewData(allOrgIds, selectedRange[0], selectedSource, selectedMedium,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType),
          getLeadsMediumsAndSources()
        ]);
      };
      
      initializeData();
    }
  }, [organizationsList]);

  useEffect(() => {
    if (activeTab === 'overview' && selectedOrganizations.length > 0) {
      abortAllRequests(activeTab);
      fetchOverviewData(selectedOrganizations, selectedRange[0], selectedSource, selectedMedium,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
    }
    else if (activeTab === 'analysis' && selectedOrganizations.length > 0) {
      abortAllRequests(activeTab);
              fetchSourceAnalysisData(selectedOrganizations, selectedRange[0], selectedSource, selectedMedium,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
    }
    else if (activeTab === 'trade_analysis' && selectedOrganizations.length > 0) {
      if(activeInnerTab === 'button_based'){
        setTradeAnalysisPagination({ current: 1, pageSize: 10, total: 0 });
        handleTradeAnalysisChange(selectedRange[0], 1, 15, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedDeviceType);
      }
      else if(activeInnerTab === 'page_based'){
        setPageAnalysisPagination({ current: 1, pageSize: 10, total: 0 });
                  handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'customer_journey'){
        abortAllRequests(activeTab);
        setCustomerJourneyPagination({ current: 1, pageSize: 10, total: 0 });
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
    }
  }, [activeTab, showUniqueData]);

  const abortAllRequests = (activeTab) => {
    if(activeTab !== 'overview'){
      if(overviewAbortController.current){
        overviewAbortController.current.abort();
      }
    }
    if(activeTab !== 'analysis'){
      if(sourceAnalysisAbortController.current){
        sourceAnalysisAbortController.current.abort();
      }
    }
    if(activeTab !== 'trade_analysis'){
      if(customerJourneyAbortController.current){
        customerJourneyAbortController.current.abort();
      }
    }
    if(activeTab !== 'page_analysis'){
      if(pageAnalysisAbortController.current){
        pageAnalysisAbortController.current.abort();
      }
    }
  }

  const fetchOverviewData = async (organizationIds, dateRange, source = null, medium = null, customerType = null, trade = null, service = null, job = null, campaign = null, deviceType = null) => {
    try {
      setDateLoading(true);
      const dateRangeToUse = dateRange || selectedRange[0];
      if (!dateRangeToUse) {
        return;
      }
      
      const start_date = dayjs(dateRangeToUse.startDate).format("YYYY-MM-DD");
      const end_date = dayjs(dateRangeToUse.endDate).format("YYYY-MM-DD");
      const organizationInfo = organizationData?.apiKeys;
      overviewAbortController.current = new AbortController();  
      
      let queryParams = `organizationIds=${organizationIds}&startDate=${start_date}&endDate=${end_date}&showUniqueData=${showUniqueData}`;
      
      if (organizationInfo?.whatConverts_profileId) {
        queryParams += `&profile_id=${organizationInfo.whatConverts_profileId}`;
      }

      if (source) queryParams += `&source=${source==='direct'?'(direct)':source}`;
      if (medium) queryParams += `&medium=${medium==='none'?'(none)':medium}`;
      if(customerType) queryParams += `&customerType=${customerType}`;
      if(trade) queryParams += `&trade=${trade}`;
      if(service) queryParams += `&service=${service}`;
      if(job) queryParams += `&job=${job}`;
      if(campaign) queryParams += `&campaign=${campaign}`;
      if(deviceType) queryParams += `&deviceType=${deviceType}`;
      
      const response = await axiosInstance.get(`/scheduler_type_multiple?${queryParams}`,{
        signal: overviewAbortController.current.signal
      });
      
      if (response.data) {
        setMergedData(response.data);
      }
    } finally {
      setDateLoading(false);
    }
  };
  
  const fetchSourceAnalysisData = async (organizationIds, dateRange, source = null, medium = null, customerType = null, trade = null, service = null, job = null, campaign = null, deviceType = null) => {
    try {
      setSourceLoading(true);
      const dateRangeToUse = dateRange || selectedRange[0];
      if (!dateRangeToUse) {
        return;
      }
      
      const start_date = dayjs(dateRangeToUse.startDate).format("YYYY-MM-DD");
      const end_date = dayjs(dateRangeToUse.endDate).format("YYYY-MM-DD");
      sourceAnalysisAbortController.current = new AbortController();
      
      let queryParams = `startDate=${start_date}&endDate=${end_date}&showUniqueData=${showUniqueData}`;
    
      if (organizationIds && organizationIds.length > 0) {
        queryParams += `&organizationIds=${organizationIds}`;
      } else {
        setSourceData([]);
        setSourceLoading(false);
        return;
      }
      if(customerType) queryParams += `&customerType=${customerType}`;
      if (source) queryParams += `&source=${source==='direct'?'(direct)':source}`;
      if (medium) queryParams += `&medium=${medium==='none'?'(none)':medium}`;
      if(trade) queryParams += `&trade=${trade}`;
      if(service) queryParams += `&service=${service}`;
      if(job) queryParams += `&job=${job}`;
      if(campaign) queryParams += `&campaign=${campaign}`;
      if(deviceType) queryParams += `&deviceType=${deviceType}`;
      
      const response = await axiosInstance.get(`/scheduler_leads_by_source?${queryParams}`,{
        signal: sourceAnalysisAbortController.current.signal
      });
      
      if (response.data) {
        setSourceData(response.data);
      }
    } finally {
      setSourceLoading(false);
    }
  };

  const handleCustomerJourneyDataViewChange = (value) => {
    setCustomerJourneyDataView(value);
    if (activeTab === 'trade_analysis' && activeInnerTab === 'customer_journey') {
      setCustomerJourneyPagination({ current: 1, pageSize: 10, total: 0 });
      handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, value, selectedCampaign, selectedBookingType, selectedDeviceType);
    }
  };

  const handleBookingTypeChange = (value) => {
    setSelectedBookingType(value);
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, value ?? null, selectedDeviceType);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, value ?? null, selectedDeviceType);
      }
    }
  };

  const handleCampaignChange = (value) => {
    setSelectedCampaign(value);
    if(activeTab === 'overview'){
      fetchOverviewData(selectedOrganizations, selectedRange[0], selectedSource, selectedMedium, selectedCustomerType, null, null, null, value ?? null, selectedDeviceType);
    }
    if (activeTab === 'analysis') {
      fetchSourceAnalysisData(selectedOrganizations, selectedRange[0], selectedSource, selectedMedium, selectedCustomerType, null, null, null, value ?? null, selectedDeviceType);
    }
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, value ?? null, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, value ?? null, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'button_based'){
        handleTradeAnalysisChange(selectedRange[0], 1, 15, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, value ?? null, selectedDeviceType);
      }
    }
  };

  const handleDateChange = async (ranges) => {
    setSelectedRange([ranges.selection]);
    setDateLoading(true);
    try {
      if (activeTab === 'trade_analysis') {
        if (activeInnerTab === 'page_based') {
          setPageAnalysisPagination({ current: 1, pageSize: 10, total: 0 });
          await handlePageAnalysisChange(selectedPage, ranges.selection, 1, 10,selectedOrganizations,selectedSource,selectedMedium,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType, selectedDeviceType);
        } else if (activeInnerTab === 'customer_journey') {
          setCustomerJourneyPagination({ current: 1, pageSize: 10, total: 0 });
          await handleCustomerJourneyChange(ranges.selection, 1, 10,selectedOrganizations,selectedSource,selectedMedium,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType, selectedDeviceType);
        } else {
          setTradeAnalysisPagination({ current: 1, pageSize: 10, total: 0 });
                      await handleTradeAnalysisChange(ranges.selection, 1, 15,selectedOrganizations,selectedSource,selectedMedium,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedDeviceType);
        }
      } else if (activeTab === 'analysis') {
        await fetchSourceAnalysisData(selectedOrganizations, ranges.selection, selectedSource, selectedMedium,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
      } else {
        await fetchOverviewData(selectedOrganizations, ranges.selection, selectedSource, selectedMedium,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
      }
    } finally {
      setDateLoading(false);
    }
  };

  const togglePicker = () => {
    setPickerOpen(!pickerOpen);
  };

  const getLeadsMediumsAndSources = async () => {
    try {
      const response = await axiosInstance.get("leads_mediums_and_sources");
      const data = await response.data?.[0];
      setLeadsSources(data.sources || []);
      setLeadMedium(data.mediums || []);
      setLeadCampaigns(data.campaigns || []);
    } catch (error) {
      console.error("Error fetching leads mediums and sources:", error);
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickInsidePicker = pickerRef.current && pickerRef.current.contains(event.target);
      if (!isClickInsidePicker) {
        setPickerOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSourceChange = (value) => {
    setSelectedSource(value);
    if(activeTab === 'overview'){
      fetchOverviewData(selectedOrganizations, selectedRange[0], value ?? null,selectedMedium,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
    }
    if (activeTab === 'analysis') {
      fetchSourceAnalysisData(selectedOrganizations, selectedRange[0], value ?? null, selectedMedium,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
    }
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, value ?? null,selectedMedium,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, value ?? null,selectedMedium,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'button_based'){
          handleTradeAnalysisChange(selectedRange[0], 1, 15, selectedOrganizations, value ?? null,selectedMedium,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedDeviceType);
      }
    }
  }
  
  const handleMediumChange = (value) => {
    setSelectedMedium(value);
    if(activeTab === 'overview'){
      fetchOverviewData(selectedOrganizations, selectedRange[0], selectedSource, value ?? null,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
    }
    if (activeTab === 'analysis') {
      fetchSourceAnalysisData(selectedOrganizations, selectedRange[0], selectedSource, value ?? null,selectedCustomerType, null, null, null, selectedCampaign, selectedDeviceType);
    }
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, value ?? null,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, selectedSource, value ?? null,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'button_based'){
        handleTradeAnalysisChange(selectedRange[0], 1, 15, selectedOrganizations, selectedSource, value ?? null,selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedDeviceType);
      }
    }
  };

  const handleCustomerTypeChange = (value) => {
    setSelectedCustomerType(value);
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, value ?? null, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, selectedSource, selectedMedium, value ?? null, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
    }
    if(activeTab === 'analysis'){
      fetchSourceAnalysisData(selectedOrganizations, selectedRange[0], selectedSource, selectedMedium, value ?? null, null, null, null, selectedCampaign, selectedDeviceType);
    }
    if(activeTab === 'overview'){
      fetchOverviewData(selectedOrganizations, selectedRange[0], selectedSource, selectedMedium, value ?? null, null, null, null, selectedCampaign, selectedDeviceType);
    }
  };

  const handleDeviceTypeChange = (value) => {
    setSelectedDeviceType(value);
    if(activeTab === 'overview'){
      fetchOverviewData(selectedOrganizations, selectedRange[0], selectedSource, selectedMedium, selectedCustomerType, null, null, null, selectedCampaign, value ?? null);
    }
    if (activeTab === 'analysis') {
      fetchSourceAnalysisData(selectedOrganizations, selectedRange[0], selectedSource, selectedMedium, selectedCustomerType, null, null, null, selectedCampaign, value ?? null);
    }
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType, value ?? null);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType, value ?? null);
      }
      else if(activeInnerTab === 'button_based'){
        handleTradeAnalysisChange(selectedRange[0], 1, 15, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, value ?? null);
      }
    }
  };

  const handleTradeChange = (value) => {
    setSelectedTrade(value);
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, value ?? null, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, value ?? null, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
    }
  };

  const handleServiceTypeChange = (value) => {
    setSelectedServiceType(value);
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, value ?? null, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, value ?? null, selectedJobType, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
    }
  };

  const handleJobTypeChange = (value) => {
    setSelectedJobType(value);
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, value ?? null, customerJourneyDataView, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, selectedRange[0], 1, 12, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, value ?? null, selectedCampaign, selectedBookingType, selectedDeviceType);
      }
    }
  };

  const handleClearFilters = () => {
    setSelectedSource(null);
    setSelectedMedium(null);
    setSelectedCustomerType(null);
    setSelectedTrade(null);
    setSelectedServiceType(null);
    setSelectedJobType(null);
    setSelectedBookingType(null);
    setSelectedCampaign(null);
    setSelectedDeviceType(null);
    const defaultDateRange = [
      {
        startDate: dayjs().startOf('month').toDate(),
        endDate: dayjs().endOf('month').toDate(),
        key: 'selection',
      },
    ];
    setSelectedRange(defaultDateRange);
    setCustomerJourneyPagination({ current: 1, pageSize: 10, total: 0 });
    setTradeAnalysisPagination({ current: 1, pageSize: 15, total: 0 });
    setPageAnalysisPagination({ current: 1, pageSize: 10, total: 0 });
    setCustomerJourneyFilters({});
    setCustomerJourneySorts({});
    setButtonAnalysisFilters({});
    setButtonAnalysisSorts({});
    setPageAnalysisFilters({});
    setPageAnalysisSorts({});
    
    // Fetch data with default values
    if(activeTab === 'overview'){
      fetchOverviewData(selectedOrganizations, defaultDateRange[0], null, null, null, null, null, null, null, null);
    }
    if (activeTab === 'analysis') {
      fetchSourceAnalysisData(selectedOrganizations, defaultDateRange[0], null, null, null, null, null, null, null, null);
    }
    if(activeTab === 'trade_analysis'){
      if(activeInnerTab === 'customer_journey'){
        handleCustomerJourneyChange(defaultDateRange[0], 1, 10, selectedOrganizations, null, null, null, null, null, null, null, null, null, null);
      }
      else if(activeInnerTab === 'page_based'){
        handlePageAnalysisChange(selectedPage, defaultDateRange[0], 1, 12, selectedOrganizations, null, null, null, null, null, null, null, null, null);
      }
      else if(activeInnerTab === 'button_based'){
        handleTradeAnalysisChange(defaultDateRange[0], 1, 15, selectedOrganizations, null, null, null, null, null, null, null, null);
      }
    }
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    if (key !== 'trade_analysis') {
      setActiveInnerTab('customer_journey');
    }
    if (key !== 'contacts') {
      setContactsDataLoaded(false);
    }
  };


  const getFilterValues = (tradeId, serviceId, jobId) => {
    const tradeName = tradeId ? trades?.find(t => t._id === tradeId)?.tradeName : null;
    const serviceName = serviceId ? services?.find(s => s.id === serviceId)?.name : null;
    const jobName = jobId ? jobs?.find(j => j._id === jobId)?.jobItem : null;
    
    return {
      trade: tradeName,
      service: serviceName,
      job: jobName
    };
  };

  const handleCustomerJourneyChange = async (dateRange = selectedRange[0], page = 1, pageSize = 10, organizationIds = selectedOrganizations, source = selectedSource, medium = selectedMedium, customerType = selectedCustomerType, trade = selectedTrade, service = selectedServiceType, job = selectedJobType, dataView = customerJourneyDataView, campaign = selectedCampaign, bookingType = selectedBookingType, deviceType = selectedDeviceType) => {
    try {
      setCustomerJourneyLoading(true);
      customerJourneyAbortController.current = new AbortController();

      const start_date = dayjs(dateRange.startDate).format("YYYY-MM-DD");
      const end_date = dayjs(dateRange.endDate).format("YYYY-MM-DD");

      let queryParams = `startDate=${start_date}&endDate=${end_date}&organizationIds=${organizationIds.join(',')}&limit=${pageSize}&page=${page}`;
      if(source) queryParams += `&source=${source}`;
      if(medium) queryParams += `&medium=${medium}`;
      if(customerType) queryParams += `&customerType=${customerType}`;
      if(dataView) queryParams += `&dataView=${dataView}`;
      if(campaign) queryParams += `&campaign=${campaign}`;
      if(bookingType) queryParams += `&lead_type=${bookingType === 'custom' ? 'quick_link' : 'standard'}`;
      if(deviceType) queryParams += `&deviceType=${deviceType}`;
      
      const filterValues = getFilterValues(trade, service, job);
      if(filterValues.trade) queryParams += `&trade=${encodeURIComponent(filterValues.trade)}`;
      if(filterValues.service) queryParams += `&service=${encodeURIComponent(filterValues.service)}`;
      if(filterValues.job) queryParams += `&job=${encodeURIComponent(filterValues.job)}`;

      const response = await axiosInstance.get(`/customer_journey?${queryParams}`, {
        signal: customerJourneyAbortController.current.signal
      });
      
      setCustomerJourneyData(response.data.data);
      setCustomerJourneyPagination({
        current: page,
        pageSize: pageSize,
        total: response.data.total
      });
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
    } finally {
      setCustomerJourneyLoading(false);
    }
  };

  const handleTradeAnalysisChange = async (dateRange = selectedRange[0], page = 1, pageSize = 15, organizationIds = selectedOrganizations, source = selectedSource, medium = selectedMedium, customerType = selectedCustomerType, trade = selectedTrade, service = selectedServiceType, job = selectedJobType, campaign = selectedCampaign, deviceType = selectedDeviceType) => {
    try {
      setTradeAnalysisLoading(true);
      tradeAnalysisAbortController.current = new AbortController();

      const start_date = dayjs(dateRange.startDate).format("YYYY-MM-DD");
      const end_date = dayjs(dateRange.endDate).format("YYYY-MM-DD");
      const response = await axiosInstance.get('/scheduler_job_analytics', {
        params: {
          startDate: start_date,
          endDate: end_date,
          organizationIds: organizationIds.join(','),
          limit: pageSize,
          page: page,
          source: source,
          medium: medium,
          customerType: customerType,
          ...(campaign && { campaign: campaign }),
          ...(deviceType && { deviceType: deviceType }),
          ...(trade && { trade: getFilterValues(trade, null, null).trade }),
          ...(service && { service: getFilterValues(null, service, null).service }),
          ...(job && { job: getFilterValues(null, null, job).job }),
        },
        signal: tradeAnalysisAbortController.current.signal
      });
      
      setTradeAnalysisData(response.data.data);
      setTradeAnalysisPagination({
        current: page,
        pageSize: pageSize,
        total: response.data.total
      });
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
    } finally {
      if (tradeAnalysisAbortController.current) {
        tradeAnalysisAbortController.current = null;
      }
      setTradeAnalysisLoading(false);
    }
  };

  const handlePageAnalysisChange = async (page, dateRange = selectedRange[0], currentPage = 1, pageSize = 10, organizationIds = selectedOrganizations, source = selectedSource, medium = selectedMedium, customerType = selectedCustomerType, trade = selectedTrade, service = selectedServiceType, job = selectedJobType, campaign = selectedCampaign, bookingType = selectedBookingType, deviceType = selectedDeviceType) => {
    try {
      setTradeAnalysisLoading(true);
      pageAnalysisAbortController.current = new AbortController();

      const start_date = dayjs(dateRange.startDate).format("YYYY-MM-DD");
      const end_date = dayjs(dateRange.endDate).format("YYYY-MM-DD");

      const filterValues = getFilterValues(trade, service, job);
      const response = await axiosInstance.get('/scheduler_page_analytics', {
        params: {
          startDate: start_date,
          endDate: end_date,
          organizationIds: organizationIds.join(','),
          limit: pageSize,
          page: currentPage,
          source: source,
          medium: medium,
          customerType: customerType,
          campaign: campaign,
          ...(deviceType && { deviceType: deviceType }),
          ...(filterValues.trade && { trade: filterValues.trade }),
          ...(filterValues.service && { service: filterValues.service }),
          ...(filterValues.job && { job: filterValues.job }),
          ...(bookingType && { lead_type: bookingType === 'custom' ? 'quick_link' : 'standard' })
        },
        signal: pageAnalysisAbortController.current.signal
      });
      
      setTradeAnalysisData(response.data.data);
      setPageAnalysisPagination({
        current: currentPage,
        pageSize: pageSize,
        total: response.data.total
      });
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
    } finally {
      if (pageAnalysisAbortController.current) {
        pageAnalysisAbortController.current = null;
      }
      setTradeAnalysisLoading(false);
    }
  };

  const getDropdownFilterProps = (searchKey, data, options = {}, currentFilters = {}, currentSorts = {}, dataIndex = null) => {
    const { useUniqueValues = true, exactMatch = true } = options;
    const actualDataIndex = dataIndex || searchKey;
    
    let filters;
    if (useUniqueValues) {
      filters = [...new Set(data.map(item => item[actualDataIndex]))]
        .filter(value => value != null)
        .map(value => ({ text: value, value: value }));
    } else {
      filters = data.map(item => ({ text: item[actualDataIndex], value: item[actualDataIndex] }));
    }

    return {
      filters,
      filteredValue: currentFilters[searchKey] || null,
      onFilter: exactMatch 
        ? (value, record) => record[actualDataIndex] === value
        : (value, record) => {
            const fieldValue = record[actualDataIndex];
            if (!fieldValue) return false;
            return fieldValue.toString().toLowerCase().includes(value.toLowerCase());
          },
      filterSearch: true,
      sorter: (a, b) => {
        if (typeof a[actualDataIndex] === 'string') {
          return a[actualDataIndex].localeCompare(b[actualDataIndex]);
        }
        return a[actualDataIndex] - b[actualDataIndex];
      },
      sortOrder: currentSorts.columnKey === searchKey ? currentSorts.order : null,
    };
  };
  
  const getColumnSearchPropsWithFilters = (searchKey, currentFilters = {}, dataIndex = null) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${searchKey}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button
            onClick={() => confirm()}
            style={{ width: 90 }}
          >
            Search
          </button>
          <button 
            onClick={() => {
              clearFilters();
              setSelectedKeys([]);
              confirm();
            }} 
            style={{ width: 90 }}
          >
            Reset
          </button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      const fieldValue = record[dataIndex || searchKey];
      if (!fieldValue) return false;
      return fieldValue.toString().toLowerCase().includes(value.toLowerCase());
    },
    filteredValue: currentFilters[searchKey] || null,
  });
  
  const handleCustomerJourneyTableChange = (pagination, filters, sorter) => {
    setCustomerJourneyFilters(filters);
    setCustomerJourneySorts(sorter);
    const filtersChanged = JSON.stringify(filters) !== JSON.stringify(customerJourneyFilters);
    const newPage = filtersChanged ? 1 : (pagination.current || 1);
    const newPageSize = pagination.pageSize || 10;
    
    setCustomerJourneyPagination({
      current: newPage,
      pageSize: newPageSize,
      total: customerJourneyPagination.total
    });
    if (pagination.current !== customerJourneyPagination.current || pagination.pageSize !== customerJourneyPagination.pageSize) {
      handleCustomerJourneyChange(selectedRange[0], pagination.current || 1, pagination.pageSize || 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType);
    }
  };

  const handleTradeAnalysisTableChange = (pagination, filters, sorter) => {
    setButtonAnalysisFilters(filters);
    setButtonAnalysisSorts(sorter);
    const filtersChanged = JSON.stringify(filters) !== JSON.stringify(buttonAnalysisFilters);
    const newPage = filtersChanged ? 1 : (pagination.current || 1);
    const newPageSize = pagination.pageSize || 15;
    
    setTradeAnalysisPagination({
      current: newPage,
      pageSize: newPageSize,
      total: tradeAnalysisPagination.total
    });

    if (pagination.current !== tradeAnalysisPagination.current || pagination.pageSize !== tradeAnalysisPagination.pageSize) {
      handleTradeAnalysisChange(selectedRange[0], pagination.current || 1, pagination.pageSize || 15, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign);
    }
  };

  const handlePageAnalysisTableChange = (pagination, filters, sorter) => {
    setPageAnalysisFilters(filters);
    setPageAnalysisSorts(sorter);
    const filtersChanged = JSON.stringify(filters) !== JSON.stringify(pageAnalysisFilters);
    const newPage = filtersChanged ? 1 : (pagination.current || 1);
    const newPageSize = pagination.pageSize || 10;
    
    setPageAnalysisPagination({
      current: newPage,
      pageSize: newPageSize,
      total: pageAnalysisPagination.total
    });
    if (pagination.current !== pageAnalysisPagination.current || pagination.pageSize !== pageAnalysisPagination.pageSize) {
      handlePageAnalysisChange(null, selectedRange[0], pagination.current || 1, pagination.pageSize || 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType);
    }
  };

  const exportToExcel =async () => {
    try {
      setExportLoading(true);
      await new Promise(resolve => setTimeout(resolve, 100));
      
      let exportData = [];
      let fileName = '';
      let sheetName = '';

      switch (activeTab) {
        case 'overview':
          if (!mergedData || mergedData.length === 0) {
            console.log('No overview data to export');
            return;
          }
          exportData = mergedData.map(item => ({
            'Organization': item.organization_name,
            'Unique Leads': item.total_unique_leads,
            'Unique Bookings': item.total_bookings,
            'Unique Abandonments': item.total_abandonments,
            'Unique Booking Rate (%)': `${item.booking_rate_percentage.toFixed(2)}%`,
            'Unique Abandonment Rate (%)': `${item.abandonment_rate_percentage?.toFixed(2) || 0}%`
          }));
          fileName = 'overview_analytics';
          sheetName = 'Overview Analytics';
          break;

        case 'analysis':
          if (!sourceData || sourceData.length === 0) {
            console.log('No source data to export');
            return;
          }
          exportData = sourceData.map(item => {
            let source = item.lead_source || '(not set)';
            let medium = item.lead_medium || '(not set)';
            
            if (source === 'direct') source = '(direct)';
            if (medium === 'none') medium = '(none)';
            
            return {
              'Source': source,
              'Medium': medium,
              'Unique Bookings': item.total_bookings,
              'Unique Abandonments': item.total_abandonments,
              'Unique Booking Rate (%)': `${item.booking_rate_percentage?.toFixed(2) || 0}%`
            };
          });
          fileName = 'source_medium_analysis';
          sheetName = 'Source & Medium Analysis';
          break;

        case 'trade_analysis':
          if (activeInnerTab === 'customer_journey') {
            if (!customerJourneyData || customerJourneyData.length === 0) {
              console.log('No customer journey data to export');
              return;
            }
            exportData = customerJourneyData.map(item => {
              return {
                'Organization': item.organization_name,
                'Customer Name': item.customer_name,
                'Customer Email': item.customer_email,
                'Type': item.lead_type === 'quick_link' ? 'Quick Link' : 'Standard',
                'Customer Journey': item.complete_journey || 'No journey data',
                'First Click': item.first_click_time ? dayjs.utc(item.first_click_time?.value || item.first_click_time).local().format('MM/DD/YY HH:mm:ss') : '-',
                'Last Click': item.last_click_time ? dayjs.utc(item.last_click_time?.value || item.last_click_time).local().format('MM/DD/YY HH:mm:ss') : '-',
                'Session Duration (seconds)': item.first_click_time && item.last_click_time ? 
                  dayjs(item.last_click_time?.value || item.last_click_time).diff(dayjs(item.first_click_time?.value || item.first_click_time), 'second') : 0,
                'Clicks': item.total_interactions
              };
            });
            fileName = 'customer_journey_analysis';
            sheetName = 'Customer Journey';
          } else if (activeInnerTab === 'button_based') {
            if (!tradeAnalysisData || tradeAnalysisData.length === 0) {
              console.log('No button analysis data to export');
              return;
            }
            exportData = tradeAnalysisData.map(item => ({
              'Organization': item.organization_name,
              'Button Action': (() => {
                const buttonValue = item.button_name;
                if (!buttonValue) return '';
                if (buttonValue.includes('Last selected time slot')) {
                  return buttonValue.replace('Last selected time slot: ', '');
                }
                if (buttonValue.includes(' - ')) {
                  const parts = buttonValue.split(' - ');
                  return parts[parts.length - 1];
                }
                return buttonValue;
              })(),
              'Selection Made': item.button_value,
              'Associated Page': item.page_name || 'Unknown Page',
              'Abandonments': item.drop_off_count
            }));
            fileName = 'button_abandonment_analysis';
            sheetName = 'Button Analysis';
          } else if (activeInnerTab === 'page_based') {
            if (!tradeAnalysisData || tradeAnalysisData.length === 0) {
              console.log('No page analysis data to export');
              return;
            }
            exportData = tradeAnalysisData.map(item => ({
              'Organization': item.organization_name,
              'Page Name': item.page_name,
              'Total Visitors': item.total_visitors,
              'Abandoned on Page': item.abandoned_on_page,
              'Abandonment Rate (%)': `${item.abandonment_rate_percentage?.toFixed(1) || 0}%`
            }));
            fileName = 'page_abandonment_analysis';
            sheetName = 'Page Analysis';
          }
          break;

        case 'contacts':
          if (!detailedAnalysisRef.current || !detailedAnalysisRef.current.detailedAnalysisData || detailedAnalysisRef.current.detailedAnalysisData.length === 0) {
            console.log('No contacts data to export');
            return;
          }
          detailedAnalysisRef.current.exportToExcel();
          break;

        default:
          console.log('Unknown active tab for export');
          return;
      }

      if (exportData.length === 0) {
        console.log('No export data generated');
        return;
      }

      if(activeTab === 'contacts'){
        if (detailedAnalysisRef.current && detailedAnalysisRef.current.exportToExcel) {
          detailedAnalysisRef.current.exportToExcel();
        } else {
          console.error('DetailedAnalysis ref or exportToExcel method not available');
        }
        return;
      }

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const dataBlob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      saveAs(dataBlob, `${fileName}_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`);
    }finally {
      setExportLoading(false);
    }
  }

  const SpinnerLoader = ({ message = "Loading..." }) => (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: '60px 20px',
      textAlign: 'center' 
    }}>
      <Spin size="large" />
      <div style={{ marginTop: '16px', color: '#666', fontSize: '14px' }}>
        {message}
      </div>
    </div>
  );
  
  return (
    <>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        marginBottom: '20px' 
      }}>
        <Tooltip title={
          activeTab === 'overview' ? 'Export overview analytics data to Excel' :
          activeTab === 'analysis' ? 'Export source and medium analysis data to Excel' :
          activeTab === 'trade_analysis' ? 
            (activeInnerTab === 'customer_journey' ? 'Export customer journey data to Excel' :
             activeInnerTab === 'button_based' ? 'Export button abandonment analysis to Excel' :
             activeInnerTab === 'page_based' ? 'Export page abandonment analysis with visitor flow data to Excel' :
             'Export job abandonment analysis to Excel') :
          'Export current data to Excel'
        }>
          <Button
            icon={<FileExcelOutlined />}
            loading={exportLoading}
            onClick={exportToExcel}
            disabled={(() => {
              switch (activeTab) {
                case 'overview':
                  return !mergedData || mergedData.length === 0;
                case 'analysis':
                  return !sourceData || sourceData.length === 0;
                case 'trade_analysis':
                  return activeInnerTab === 'customer_journey' 
                    ? !customerJourneyData || customerJourneyData.length === 0
                    : !tradeAnalysisData || tradeAnalysisData.length === 0;
                case 'contacts':
                  return !contactsDataLoaded || !detailedAnalysisRef.current || !detailedAnalysisRef.current.detailedAnalysisData || detailedAnalysisRef.current.detailedAnalysisData.length === 0;
                default:
                  return true;
              }
            })()}
            style={{
              backgroundColor: (() => {
                switch (activeTab) {
                  case 'overview':
                    return (mergedData && mergedData.length > 0) ? '#10b981' : '#e5e7eb';
                  case 'analysis':
                    return (sourceData && sourceData.length > 0) ? '#10b981' : '#e5e7eb';
                  case 'trade_analysis':
                    return (activeInnerTab === 'customer_journey' 
                      ? (customerJourneyData && customerJourneyData.length > 0)
                      : (tradeAnalysisData && tradeAnalysisData.length > 0)) ? '#10b981' : '#e5e7eb';
                  case 'contacts':
                    return (contactsDataLoaded && detailedAnalysisRef.current && detailedAnalysisRef.current.detailedAnalysisData && detailedAnalysisRef.current.detailedAnalysisData.length > 0) ? '#10b981' : '#e5e7eb';
                  default:
                    return '#e5e7eb';
                }
              })(),
              color: (() => {
                switch (activeTab) {
                  case 'overview':
                    return (mergedData && mergedData.length > 0) ? '#fff' : '#9ca3af';
                  case 'analysis':
                    return (sourceData && sourceData.length > 0) ? '#fff' : '#9ca3af';
                  case 'trade_analysis':
                    return (activeInnerTab === 'customer_journey' 
                      ? (customerJourneyData && customerJourneyData.length > 0)
                      : (tradeAnalysisData && tradeAnalysisData.length > 0)) ? '#fff' : '#9ca3af';
                  case 'contacts':
                    return (contactsDataLoaded && detailedAnalysisRef.current && detailedAnalysisRef.current.detailedAnalysisData && detailedAnalysisRef.current.detailedAnalysisData.length > 0) ? '#fff' : '#9ca3af';
                  default:
                    return '#9ca3af';
                }
              })(),
              border: 'none',
              fontWeight: '500',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            Export to Excel
          </Button>
        </Tooltip>
      </div>
      
      <Card>
        <Tabs 
          activeKey={activeTab} 
          onChange={handleTabChange}
          type="card"
          style={{ marginBottom: '20px' }}
        >
          <TabPane tab={
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span>📈 Overview</span>
              <Popover 
                content={
                  <div style={{ maxWidth: '400px' }}>
                    <div style={{ marginBottom: '8px', fontWeight: '600', color: '#059669' }}>
                      📈 Business Performance Overview
                    </div>
                    <div style={{ fontSize: '12px', color: '#4b5563' }}>
                      📊 What this shows: Your overall business performance including Leads received, Bookings, and Abandonments.
                      <div style={{ marginTop: '8px' }}>
                        • Understanding Data Format:
                        <ul style={{ marginLeft: '16px', marginTop: '4px' }}>
                          <li><strong>Unique Leads:</strong> Individual customers who started booking<br/><strong>Total Leads:</strong> All booking attempts including repeats</li>
                          <li><strong>Unique Bookings:</strong> Customers who completed booking<br/><strong>Total Bookings:</strong> All successful completions including repeats</li>
                          <li><strong>Unique Abandonments:</strong> Customers who started but didn't finish<br/><strong>Total Abandonments:</strong> All incomplete attempts including repeats</li>
                          <li><strong>Booking Rate:</strong> Percentage showing how well you convert leads to bookings</li>
                          <li><strong>Abandonment Rate:</strong> Percentage showing how many leads abandoned the booking process</li>
                        </ul>
                      </div>
                      <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#fef3c7', border: '1px solid #fbbf24', borderRadius: '4px', fontSize: '11px', color: '#92400e' }}>
                        <strong>⏰ Note:</strong> Reports update every 24 hours. Recent activity may take up to 24 hours to appear.
                      </div>
                    </div>
                  </div>
                }
                placement="right"
                trigger="hover"
              >
                <span style={{ opacity: 0.7, fontSize: '14px', cursor: 'help' }}>ⓘ</span>
              </Popover>
            </span>
          } key="overview">
          </TabPane>
          
          <TabPane tab={
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span>🎯 Source,Medium & Campaign Analysis</span>
              <Popover 
                content={
                  <div style={{ maxWidth: '400px' }}>
                    <div style={{ marginBottom: '8px', fontWeight: '600', color: '#d97706' }}>
                      🎯 Marketing Channel Performance
                    </div>
                    <div style={{ fontSize: '12px', color: '#4b5563' }}>
                      📊 What this shows: Which marketing channels are bringing you the most customers and which ones convert best into actual bookings.
                      <div style={{ marginTop: '8px' }}>
                        • Understanding Data Format:
                        <ul style={{ marginLeft: '16px', marginTop: '4px' }}>
                          <li><strong>Traffic Sources:</strong> Where customers found you (Google, Facebook, Direct, etc.)</li>
                          <li><strong>Traffic Mediums:</strong> How they reached you (organic, paid, social, email)</li>
                          <li><strong>Campaigns:</strong> Which campaigns are driving the most traffic and conversions</li>
                          <li><strong>{showUniqueData ? 'Unique' : 'Total'} Booking Rates:</strong> Which channels convert visitors into actual bookings</li>
                          <li><strong>{showUniqueData ? 'Unique' : 'Total'} Abandonment Rates:</strong> Which channels have higher customer drop-off rates</li>
                          <li><strong>Performance Comparison:</strong> Compare different marketing investments and identify optimization opportunities</li>
                        </ul>
                      </div>
                      <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#fef3c7', border: '1px solid #fbbf24', borderRadius: '4px', fontSize: '11px', color: '#92400e' }}>
                        <strong>⏰ Note:</strong> Reports update every 24 hours. Recent activity may take up to 24 hours to appear.
                      </div>
                    </div>
                  </div>
                }
                placement="right"
                trigger="hover"
              >
                <span style={{ opacity: 0.7, fontSize: '14px', cursor: 'help' }}>ⓘ</span>
              </Popover>
            </span>
          } key="analysis">
          </TabPane>
          
          <TabPane tab={
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span>🚪 Customer Journey Analysis</span>
              <Popover 
                content={
                                      <div style={{ maxWidth: '400px' }}>
                      <div style={{ marginBottom: '8px', fontWeight: '600', color: '#dc2626' }}>
                        🚪 Customer Journey Analysis
                      </div>
                      <div style={{ fontSize: '12px', color: '#4b5563' }}>
                        📊 What this shows: Detailed analysis of customers who abandoned their appointment booking process, showing exactly where they dropped off.
                        <div style={{ marginTop: '8px' }}>
                          • Analysis Structure:
                          <ul style={{ marginLeft: '16px', marginTop: '4px' }}>
                            <li><strong>🗺️ Customer Journey:</strong> Complete abandonment paths showing every step customers took before abandoning the scheduler</li>
                            <li><strong>🔘 Button Analysis:</strong> Customers whose last action was clicking a button before abandoning</li>
                            <li><strong>📄 Page Analysis:</strong> Customers who viewed a page and then abandoned without taking action</li>
                          </ul>
                        </div>
                        <div style={{ 
                          marginTop: '12px', 
                          padding: '8px', 
                          backgroundColor: '#fef3c7', 
                          border: '1px solid #fbbf24', 
                          borderRadius: '4px', 
                          fontSize: '11px', 
                          color: '#92400e' 
                        }}>
                          <strong>ℹ️ Abandonment Analysis Scope:</strong> This analysis tracks customers who reached at least the Trade Selection page but never completed their booking. Customers who never progressed beyond the Customer Information & Address page are not included in this abandonment data.
                        </div>
                      </div>
                    </div>
                }
                placement="right"
                trigger="hover"
              >
                <span style={{ opacity: 0.7, fontSize: '14px', cursor: 'help' }}>ⓘ</span>
              </Popover>
            </span>
          } key="trade_analysis">
          </TabPane>
          
          <TabPane tab={
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <BiAnalyse/>
              <span>Contacts</span>
              <Popover 
                content={
                  <div style={{maxWidth: '400px' }}>
                    <div style={{ marginBottom: '8px', fontWeight: '600', color: '#7c3aed' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <BiAnalyse/>
                        <span>Contacts</span>
                      </div>
                    </div>
                    <div style={{ fontSize: '12px', color: '#4b5563' }}>
                      📊 What this shows: View what converts data regarding bookings and abandonments.
                    </div>
                  </div>
                }
                placement="right"
                trigger="hover"
              >
                <span style={{ opacity: 0.7, fontSize: '14px', cursor: 'help' }}>ⓘ</span>
              </Popover>
            </span>
          } key="contacts">
          </TabPane>
          

        </Tabs>
        
        {activeTab !== 'contacts' && (
          <AnalyticsHeader 
            pickerRef={pickerRef}
            selectedRange={selectedRange}
            togglePicker={togglePicker}
            pickerOpen={pickerOpen}
            handleDateChange={handleDateChange}
            organizationsList={isAdmin ? organizationsList : organizationsList?.filter((item) => currentOrganizationIds?.includes(item?._id))}
            selectedOrganizations={localSelectedOrgs}
            handleOrganizationChange={handleLocalOrgChange}
            activeTab={activeTab}
            activeInnerTab={activeInnerTab}
            selectedSource={selectedSource}
            selectedMedium={selectedMedium}
            handleSourceChange={handleSourceChange}
            handleMediumChange={handleMediumChange}
            handleClearFilters={handleClearFilters}
            leads_sources={leads_sources}
            lead_medium={lead_medium}
            filtersLoading={filtersLoading}
            showUniqueData={showUniqueData}
            setShowUniqueData={setShowUniqueData}
            selectedCustomerType={selectedCustomerType}
            handleCustomerTypeChange={handleCustomerTypeChange}
            selectedTrade={selectedTrade}
            selectedServiceType={selectedServiceType}
            selectedJobType={selectedJobType}
            handleTradeChange={handleTradeChange}
            handleServiceTypeChange={handleServiceTypeChange}
            handleJobTypeChange={handleJobTypeChange}
            trades={trades}
            services={services}
            jobs={jobs}
            customerJourneyDataView={customerJourneyDataView}
            handleCustomerJourneyDataViewChange={handleCustomerJourneyDataViewChange}
            selectedDeviceType={selectedDeviceType}
            handleDeviceTypeChange={handleDeviceTypeChange}
            selectedBookingType={selectedBookingType}
            handleBookingTypeChange={handleBookingTypeChange}
            selectedCampaign={selectedCampaign}
            handleCampaignChange={handleCampaignChange}
            lead_campaigns={lead_campaigns}
          />
        )}

        {activeTab === 'overview' && (
          (loading || dateLoading) ? (
            <SpinnerLoader message="Loading organization analytics data..." />
          ) : (
            <AnalyticsTable 
              mergedData={mergedData}
              loading={false}
              showUniqueData={showUniqueData}
            />
          )
        )}

        {activeTab === 'analysis' && (
          sourceLoading ? (
            <SpinnerLoader message="Loading source and booking rate analysis..." />
          ) : selectedOrganizations.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '40px 20px',
              background: '#fafafa',
              borderRadius: '8px',
              border: '1px dashed #d9d9d9'
            }}>
              <div style={{ fontSize: '16px', color: '#666', marginBottom: '8px' }}>
                🏢 No Organizations Selected
              </div>
              <p style={{ color: '#999', margin: 0 }}>
                Please select at least one organization from the dropdown above to view marketing channel analysis.
              </p>
            </div>
          ) : (
            <CombinedAnalysisChart 
              sourceData={sourceData}
              sourceLoading={false}
              showUniqueData={showUniqueData}
            />
          )
        )}

        {activeTab === 'trade_analysis' && (
          <Tabs defaultActiveKey="customer_journey"
              onChange={(key) => {
                if (tradeAnalysisAbortController.current) {
                  tradeAnalysisAbortController.current.abort();
                  tradeAnalysisAbortController.current = null;
                }
                if (pageAnalysisAbortController.current) {
                  pageAnalysisAbortController.current.abort();
                  pageAnalysisAbortController.current = null;
                }
                if (customerJourneyAbortController.current) {
                  customerJourneyAbortController.current.abort();
                  customerJourneyAbortController.current = null;
                }
                setCustomerJourneyFilters({});
                setCustomerJourneySorts({});
                setButtonAnalysisFilters({});
                setButtonAnalysisSorts({});
                setPageAnalysisFilters({});
                setPageAnalysisSorts({});
                setCustomerJourneyPagination({ current: 1, pageSize: 10, total: 0 });
                setTradeAnalysisPagination({ current: 1, pageSize: 15, total: 0 });
                setPageAnalysisPagination({ current: 1, pageSize: 10, total: 0 });

                setActiveInnerTab(key);
                if (key === 'page_based') {
                  setPageAnalysisPagination({ current: 1, pageSize: 10, total: 0 });
                  handlePageAnalysisChange(null, selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign, selectedBookingType);
                } else if (key === 'customer_journey') {
                  setCustomerJourneyPagination({ current: 1, pageSize: 10, total: 0 });
                  handleCustomerJourneyChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, customerJourneyDataView, selectedCampaign, selectedBookingType);
                } else {
                  setSelectedPage(null);
                  setTradeAnalysisPagination({ current: 1, pageSize: 10, total: 0 });
                                      handleTradeAnalysisChange(selectedRange[0], 1, 10, selectedOrganizations, selectedSource, selectedMedium, selectedCustomerType, selectedTrade, selectedServiceType, selectedJobType, selectedCampaign);
                }
              }}
            >
                            <TabPane tab={
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <InteractionOutlined style={{ color: '#1890ff' }} />
                  <span>Clicks Analysis</span>
                  <Popover 
                    content={
                      <div style={{ maxWidth: '400px' }}>
                        <div style={{ marginBottom: '8px', fontWeight: '600', color: '#1890ff' }}>
                          💡 Clicks Analysis
                        </div>
                        <div style={{ fontSize: '12px', color: '#4b5563' }}>
                          📊 What this shows: Complete customer journeys showing every step customers took through your scheduling process, with the ability to view both abandoned and booked journeys.
                          <div style={{ marginTop: '8px' }}>
                            • View Options:
                            <ul style={{ marginLeft: '16px', marginTop: '4px' }}>
                              <li>🔴 Abandoned Journeys: Paths where customers left without booking</li>
                              <li>✅ Booked Journeys: Successful paths leading to completed bookings</li>
                            </ul>
                            • Understanding Data Format:
                            <ul style={{ marginLeft: '16px', marginTop: '4px' }}>
                              <li>Journey Path: Page visits and button clicks in sequence</li>
                              <li>Booking Type: 🔗 Custom Link (bypassed Trade Selection) or 🔄 Standard Flow (normal process)</li>
                              <li>Time Data: First click, last click, and session duration</li>
                              <li>Interaction Count: Total clicks and selections made</li>
                              <li>Customer Info: Name, email, and organization details</li>
                            </ul>
                            <div style={{ 
                              marginTop: '12px',
                              backgroundColor: '#f8fafc',
                              border: '1px solid #e2e8f0',
                              borderRadius: '6px',
                              padding: '8px'
                            }}>
                              <div style={{ fontWeight: '600', marginBottom: '6px', color: '#334155' }}>
                                🎨 Journey Element Colors
                              </div>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#e6f7ff',
                                  border: '1px solid #91d5ff',
                                  color: '#1890ff',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> Page Views
                                </div>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#fff7e6',
                                  border: '1px solid #ffd591',
                                  color: '#d46b08',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> Button Clicks
                                </div>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#f6f6f6',
                                  border: '1px solid #ffa39e',
                                  color: '#ff4d4f',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> Back Button
                                </div>
                              </div>
                              <div style={{ 
                                marginTop: '8px', 
                                fontWeight: '600', 
                                marginBottom: '6px', 
                                color: '#334155' 
                              }}>
                                ⏱️ Session Duration Colors
                              </div>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#fff2f2',
                                  border: '1px solid #ffa39e',
                                  color: '#ff4d4f',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> Short (1m)
                                </div>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#fff7e6',
                                  border: '1px solid #ffd591',
                                  color: '#faad14',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> Medium (1-5m)
                                </div>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#f6ffed',
                                  border: '1px solid #b7eb8f',
                                  color: '#52c41a',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> Long ({'>'}5m)
                                </div>
                              </div>
                            </div>
                          </div>
                          <div style={{ marginTop: '8px', fontStyle: 'italic', color: '#6b7280' }}>
                            💡 Pro Tip: This complete view is filtered in Button Analysis (button-ending journeys) and Page Analysis (page-ending journeys) for specific insights.
                          </div>
                        </div>
                      </div>
                    }
                    placement="right"
                    trigger="hover"
                  >
                    <span style={{ opacity: 0.7, fontSize: '14px', cursor: 'help' }}>ⓘ</span>
                  </Popover>
                </span>
              } key="customer_journey">
                <div style={{ marginBottom: '20px' }}>
                  {customerJourneyLoading ? (
                    <SpinnerLoader message="Loading customer journey analysis..." />
                  ) : customerJourneyData.length === 0 ? (
                    <div style={{ 
                      textAlign: 'center', 
                      padding: '60px 20px',
                      background: '#fafafa',
                      borderRadius: '8px',
                      border: '1px dashed #d9d9d9'
                    }}>
                      <div style={{ fontSize: '16px', color: '#666', marginBottom: '8px' }}>
                        📊 No Customer Journey Data Found
                      </div>
                      <p style={{ color: '#999', margin: 0 }}>
                        Customer journey data will appear here for the selected date range and organizations.<br/>
                        Try adjusting your date range or check if there are customers with completed journeys.
                      </p>
                    </div>
                  ) : (
                    <div>
                      
                      <Table
                        dataSource={customerJourneyData}
                        loading={customerJourneyLoading}
                        rowKey={(record, index) => `${record.customer_email}_${index}`}
                        onChange={handleCustomerJourneyTableChange}
                        columns={[
                          {
                            title: "Organization",
                            dataIndex: 'organization_name',
                            key: 'organization_name',
                            sorter: (a, b) => a.organization_name.localeCompare(b.organization_name),
                            sortOrder: customerJourneySorts.columnKey === 'organization_name' ? customerJourneySorts.order : null,
                            render: (org) => (
                              <span style={{ 
                                fontSize: '12px',
                                fontWeight: '500'
                              }}>
                                {org}
                              </span>
                            ),
                            width: 130,
                          },
                          {
                            title: "Customer Name",
                            dataIndex: 'customer_name',
                            key: 'customer_name',
                            ...getColumnSearchPropsWithFilters('customer_name', customerJourneyFilters, 'customer_name'),
                            sorter: (a, b) => a.customer_name.localeCompare(b.customer_name),
                            sortOrder: customerJourneySorts.columnKey === 'customer_name' ? customerJourneySorts.order : null,
                            render: (name, record) => (
                              <Popover 
                                content={
                                  <div style={{ padding: '8px' }}>
                                    <div style={{ fontWeight: '600', marginBottom: '4px' }}>Contact Information</div>
                                    <div style={{ fontSize: '13px', color: '#666' }}>
                                      Email: {record.customer_email}
                                    </div>
                                  </div>
                                }
                                trigger="hover"
                                placement="right"
                              >
                                <span style={{ fontWeight: '600', color: '#1890ff', cursor: 'pointer' }}>
                                  {name}
                                </span>
                              </Popover>
                            ),
                            width: 120,
                          },

                          {
                            title: "Customer Selections",
                            dataIndex: 'complete_journey',
                            key: 'complete_journey',
                            ...getColumnSearchPropsWithFilters('complete_journey', customerJourneyFilters, 'complete_journey'),
                            sorter: (a, b) => {
                              const selectionsA = a.complete_journey ? a.complete_journey.split(' → ').length : 0;
                              const selectionsB = b.complete_journey ? b.complete_journey.split(' → ').length : 0;
                              return selectionsA - selectionsB;
                            },
                            sortOrder: customerJourneySorts.columnKey === 'complete_journey' ? customerJourneySorts.order : null,
                            render: (selections) => {
                              if (!selections) return <span style={{ color: '#999' }}>No selections made</span>;
                              
                              const steps = selections.split(' → ');
                              return (
                                <div style={{ 
                                  maxWidth: '350px', 
                                  lineHeight: '1.8',
                                  fontSize: '11px'
                                }}>
                                  {steps.map((step, index) => {
                                    const cleanStep = step.trim();
                                    const isPageStep = cleanStep.startsWith('page:');
                                    const isButtonStep = cleanStep.startsWith('button:');
                                    const stepValue = isPageStep 
                                      ? cleanStep.replace('page:', '').trim()
                                      : isButtonStep 
                                        ? cleanStep.replace('button:', '').trim()
                                        : cleanStep;
                                    
                                    let displayValue = stepValue;
                                    if (isButtonStep) {
                                      if (stepValue.toLowerCase().includes('last selected time slot')) {
                                        displayValue = stepValue.replace(/last selected time slot\s*/i, '').trim();
                                      } else {
                                        displayValue = stepValue.includes(' - ') 
                                          ? stepValue.split(' - ').pop().trim()
                                          : stepValue;
                                      }
                                    }
                                    
                                    // Capitalize the first word
                                    displayValue = displayValue.charAt(0).toUpperCase() + displayValue.slice(1);

                                    const getStyles = () => {
                                      if(stepValue === 'Back'){
                                        return {
                                          background: '#f6f6f6',
                                          color: '#ff4d4f',
                                          border: '1px solid #ffa39e',
                                          arrowColor: '#ff4d4f'
                                        };
                                      }
                                      if (isPageStep) {
                                        return {
                                          background: '#e6f7ff',
                                          color: '#1890ff',
                                          border: '1px solid #91d5ff',
                                          arrowColor: '#1890ff'
                                        };
                                      } else if (isButtonStep) {
                                        return {
                                          background: '#fff2e8',
                                          color: '#d46b08',
                                          border: '1px solid #ffbb96',
                                          arrowColor: '#d46b08'
                                        };
                                      } else {
                                        return {
                                          background: '#f6f6f6',
                                          color: '#666',
                                          border: '1px solid #d9d9d9',
                                          arrowColor: '#666'
                                        };
                                      }
                                    };
                                    
                                    const styles = getStyles();
                                    
                                    return (
                                      <span key={index} style={{ display: 'inline-block', margin: '2px' }}>
                                        <span style={{
                                          background: styles.background,
                                          color: styles.color,
                                          padding: '3px 7px',
                                          borderRadius: '6px',
                                          fontSize: '10px',
                                          fontWeight: '500',
                                          border: styles.border,
                                          whiteSpace: 'nowrap'
                                        }}>
                                          {displayValue}
                                        </span>
                                        {index < steps.length - 1 && (
                                          <span style={{ 
                                            color: styles.arrowColor, 
                                            margin: '0 4px',
                                            fontWeight: 'bold',
                                            fontSize: '11px'
                                          }}>→</span>
                                        )}
                                      </span>
                                    );
                                  })}
                                </div>
                              );
                            },
                            width: 300,
                          },
                          {
                            title: "First Click",
                            dataIndex: 'first_click_time',
                            key: 'first_click_time',
                            render: (timeObj) => {
                              const time = timeObj?.value || timeObj;
                              if (!time) return '-';
                              const date = dayjs.utc(time).local();
                              return (
                                <div style={{ fontSize: '12px' }}>
                                  <div style={{ fontWeight: '500', color: '#1890ff' }}>
                                    {date.format('MM/DD/YY')}
                                  </div>
                                  <div style={{ color: '#666' }}>
                                    {date.format("h:mm A")}
                                  </div>
                                </div>
                              );
                            },
                            sorter: (a, b) => {
                              const timeA = a.first_click_time?.value || a.first_click_time;
                              const timeB = b.first_click_time?.value || b.first_click_time;
                              return dayjs(timeA).unix() - dayjs(timeB).unix();
                            },
                            sortOrder: customerJourneySorts.columnKey === 'first_click_time' ? customerJourneySorts.order : null,
                            width: 80
                          },
                          {
                            title: "Last Click",
                            dataIndex: 'last_click_time',
                            key: 'last_click_time',
                            render: (timeObj) => {
                              const time = timeObj?.value || timeObj;
                              if (!time) return '-';
                              const date = dayjs.utc(time).local();
                              return (
                                <div style={{ fontSize: '12px' }}>
                                  <div style={{ fontWeight: '500', color: '#1890ff' }}>
                                    {date.format('MM/DD/YY')}
                                  </div>
                                  <div style={{ color: '#666' }}>
                                    {date.format("h:mm A")}
                                  </div>
                                </div>
                              );
                            },
                            sorter: (a, b) => {
                              const timeA = a.last_click_time?.value || a.last_click_time;
                              const timeB = b.last_click_time?.value || b.last_click_time;
                              return dayjs(timeA).unix() - dayjs(timeB).unix();
                            },
                            sortOrder: customerJourneySorts.columnKey === 'last_click_time' ? customerJourneySorts.order : null,
                            width: 80
                          },
                          {
                            title: "Session Duration",
                            key: 'session_duration',
                            render: (_, record) => {
                              const startTime = record.first_click_time?.value || record.first_click_time;
                              const endTime = record.last_click_time?.value || record.last_click_time;
                              
                              if (!startTime || !endTime) return '-';
                              
                              const duration = dayjs(endTime).diff(dayjs(startTime), 'second');
                              const minutes = Math.floor(duration / 60);
                              const seconds = duration % 60;
                              
                              const formatTime = minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
                              const colorClass = duration > 300 ? '#52c41a' : duration > 60 ? '#faad14' : '#ff4d4f';
                              
                              return (
                                <span style={{ 
                                  color: colorClass, 
                                  fontWeight: '600',
                                  fontSize: '12px'
                                }}>
                                  {formatTime}
                                </span>
                              );
                            },
                            sorter: (a, b) => {
                              const durationA = dayjs(a.last_click_time?.value || a.last_click_time)
                                .diff(dayjs(a.first_click_time?.value || a.first_click_time), 'second');
                              const durationB = dayjs(b.last_click_time?.value || b.last_click_time)
                                .diff(dayjs(b.first_click_time?.value || b.first_click_time), 'second');
                              return durationA - durationB;
                            },
                            sortOrder: customerJourneySorts.columnKey === 'session_duration' ? customerJourneySorts.order : null,
                            width: 80
                          },
                          {
                            title: "Clicks",
                            dataIndex: 'total_interactions',
                            key: 'total_interactions',
                            align: 'center',
                            render: (interactions) => (
                              <div style={{ textAlign: 'center' }}>
                                <span style={{ 
                                  background: interactions > 30 ? '#ff4d4f' : interactions > 20 ? '#faad14' : interactions > 10 ? '#1890ff' : '#52c41a',
                                  color: 'white',
                                  padding: '4px 8px',
                                  borderRadius: '12px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  minWidth: '30px',
                                  display: 'inline-block'
                                }}>
                                  {interactions}
                                </span>
                              </div>
                            ),
                            sorter: (a, b) => a.total_interactions - b.total_interactions,
                            sortOrder: customerJourneySorts.columnKey === 'total_interactions' ? customerJourneySorts.order : null,
                            ...getDropdownFilterProps('total_interactions', customerJourneyData, { exactMatch: false }, customerJourneyFilters, customerJourneySorts, 'total_interactions'),
                            width: 70
                          }
                        ]}
                        pagination={{
                          current: customerJourneyPagination.current,
                          pageSize: customerJourneyPagination.pageSize,
                          total: customerJourneyPagination.total,
                          showSizeChanger: true,
                          showQuickJumper: true,
                          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} customer journeys`
                        }}
                        scroll={{ x: 'max-content' }}
                        rowClassName={(record, index) => 
                          index % 2 === 0 ? 'even-row' : 'odd-row'
                        }
                        style={{
                          background: '#fff',
                          borderRadius: '8px',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                        }}
                      />
                    </div>
                  )}
                </div>
              </TabPane>
              <TabPane tab={
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <PaperClipOutlined style={{ color: '#0369a1' }} />
                  <span>Page Abandonment Analysis</span>
                  <Popover 
                    content={
                      <div style={{ maxWidth: '400px' }}>
                        <div style={{ marginBottom: '8px', fontWeight: '600', color: '#0369a1' }}>
                          💡 Page-Level Abandonment Analysis
                        </div>
                        <div style={{ fontSize: '12px', color: '#4b5563' }}>
                          📊 What this shows: Comprehensive page-level abandonment analysis showing visitor flow and abandonment patterns at each step of your booking process.
                          <div style={{ marginTop: '8px' }}>
                            • Understanding Data Format:
                            <ul style={{ marginLeft: '16px', marginTop: '4px' }}>
                              <li><strong>Page Names:</strong> Trade Selection, Service Selection, Job Selection, etc.</li>
                              <li><strong>Total Visitors:</strong> Number of customers who reached each page</li>
                              <li><strong>Abandoned on Page:</strong> Number of customers who left at each specific page</li>
                              <li><strong>Abandonment Rate:</strong> Percentage of visitors who abandoned at each page</li>
                              <li><strong>Organization:</strong> Shows data per business unit</li>
                            </ul>
                          <div style={{ 
                              marginTop: '12px',
                            backgroundColor: '#f8fafc',
                            border: '1px solid #e2e8f0',
                            borderRadius: '6px',
                            padding: '8px'
                          }}>
                            <div style={{ fontWeight: '600', marginBottom: '6px', color: '#334155' }}>
                              🎨 Abandonment Level Colors
                            </div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                              <div style={{ 
                                padding: '4px 8px', 
                                borderRadius: '4px', 
                                backgroundColor: '#fff2f2',
                                border: '1px solid #ffa39e',
                                color: '#ff4d4f',
                                fontSize: '11px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                              }}>
                                  <span>●</span> High ({'>'}5)
                              </div>
                              <div style={{ 
                                padding: '4px 8px', 
                                borderRadius: '4px', 
                                backgroundColor: '#fff7e6',
                                border: '1px solid #ffd591',
                                color: '#faad14',
                                fontSize: '11px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                              }}>
                                <span>●</span> Medium (3-5)
                              </div>
                              <div style={{ 
                                padding: '4px 8px', 
                                borderRadius: '4px', 
                                backgroundColor: '#e6f7ff',
                                border: '1px solid #91d5ff',
                                color: '#1890ff',
                                fontSize: '11px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                              }}>
                                <span>●</span> Low (2-3)
                              </div>
                              <div style={{ 
                                padding: '4px 8px', 
                                borderRadius: '4px', 
                                backgroundColor: '#f6ffed',
                                border: '1px solid #b7eb8f',
                                color: '#52c41a',
                                fontSize: '11px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                              }}>
                                <span>●</span> Very Low (0-1)
                              </div>
                            </div>
                    <div style={{ 
                                marginTop: '8px', 
                                  fontWeight: '600',
                                marginBottom: '6px', 
                                color: '#334155' 
                              }}>
                                📊 Abandonment Rate Colors
                              </div>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#fff2f2',
                                  border: '1px solid #ffa39e',
                                  color: '#ff4d4f',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> Critical ({'>'}80%)
                                </div>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#fff7e6',
                                  border: '1px solid #ffd591',
                                  color: '#faad14',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> High (60-80%)
                                </div>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#e6f7ff',
                                  border: '1px solid #91d5ff',
                                  color: '#1890ff',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> Medium (40-60%)
                                </div>
                                <div style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  backgroundColor: '#f6ffed',
                                  border: '1px solid #b7eb8f',
                                  color: '#52c41a',
                                  fontSize: '11px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  <span>●</span> Low ({'<'}40%)
                                </div>
                              </div>
                            </div>
                          </div>
                          <div style={{ marginTop: '8px', fontStyle: 'italic', color: '#6b7280' }}>
                            💡 Pro Tip: High abandonment rates at specific pages indicate UX issues or barriers. Use this data to optimize your booking flow.
                          </div>
                        </div>
                      </div>
                    }
                    placement="right"
                    trigger="hover"
                  >
                    <span style={{ opacity: 0.7, fontSize: '14px', cursor: 'help' }}>ⓘ</span>
                  </Popover>
                </span>
              } key="page_based">
                <div style={{ marginBottom: '20px' }}>
                  {tradeAnalysisLoading ? (
                    <SpinnerLoader message="Loading page abandonment analysis..." />
                  ) : tradeAnalysisData.length === 0 ? (
                    <div style={{ 
                      textAlign: 'center', 
                      padding: '60px 20px',
                      background: '#fafafa',
                      borderRadius: '8px',
                      border: '1px dashed #d9d9d9'
                    }}>
                      <div style={{ fontSize: '16px', color: '#666', marginBottom: '8px' }}>
                        📄 No Page Abandonment Data Found
                      </div>
                      <p style={{ color: '#999', margin: 0 }}>
                        Page-level abandonment data will appear here for all organizations.<br/>
                        Data shows where customers exit the booking flow at specific page transitions.
                      </p>
                    </div>
                  ) : (
                    <div>
                      
                      <Table
                        dataSource={tradeAnalysisData}
                        loading={tradeAnalysisLoading}
                        rowKey={(record, index) => `${record.organization_name}_${record.page_name}_${index}`}
                        onChange={handlePageAnalysisTableChange}
                        columns={[
                          {
                            title: "Organization",
                            dataIndex: 'organization_name',
                            key: 'organization_name',
                            sorter: (a, b) => a.organization_name.localeCompare(b.organization_name),
                            sortOrder: pageAnalysisSorts.columnKey === 'organization_name' ? pageAnalysisSorts.order : null,
                            render: (org) => (
                              <span style={{ 
                                fontSize: '12px',
                                fontWeight: '500'
                              }}>
                                {org}
                              </span>
                            ),
                            width: 200,
                          },
                          {
                            title: "Page Name",
                            dataIndex: 'page_name',
                            key: 'page_name',
                            render: (pageName) => {
                              const pageOption = pageOptions.find(p => p.label === pageName);
                          
                              return (
                                <span style={{
                                  background: '#f0f2f5',
                                  padding: '6px 12px',
                                  borderRadius: '6px',
                                  fontSize: '13px',
                                  fontWeight: '500',
                                  color: '#595959',
                                  display: 'inline-block'
                                }}>
                                  {pageName}
                                </span>
                              );
                            },
                            filters: [...new Set(tradeAnalysisData.map(item => item.page_name))]
                              .map(value => ({ text: value, value: value })),
                            filteredValue: pageAnalysisFilters.page_name || null,
                            onFilter: (value, record) => record.page_name === value,
                            sorter: (a, b) => {
                              const aStep = pageOptions.find(p => p.label === a.page_name)?.step || 999;
                              const bStep = pageOptions.find(p => p.label === b.page_name)?.step || 999;
                              return aStep - bStep;
                            },
                            sortOrder: pageAnalysisSorts.columnKey === 'page_name' ? pageAnalysisSorts.order : null,
                            width: 250,
                          },
                          {
                            title: "Total Visitors",
                            dataIndex: 'total_visitors',
                            key: 'total_visitors',
                            render: (visitors) => (
                              <div style={{ textAlign: 'center' }}>
                                <span style={{
                                  background: '#f0f2f5',
                                  color: '#595959',
                                  padding: '4px 8px',
                                  borderRadius: '12px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  minWidth: '30px',
                                  display: 'inline-block'
                                }}>
                                  {visitors}
                                </span>
                              </div>
                            ),
                            sorter: (a, b) => a.total_visitors - b.total_visitors,
                            sortOrder: pageAnalysisSorts.columnKey === 'total_visitors' ? pageAnalysisSorts.order : null,
                            width: 120,
                          },
                          {
                            title: "Abandoned on Page",
                            dataIndex: 'abandoned_on_page',
                            key: 'abandoned_on_page',
                            render: (abandonments) => (
                              <div style={{ textAlign: 'center' }}>
                                <span style={{
                                  background: abandonments > 5 ? '#ff4d4f' : abandonments > 3 ? '#faad14' : abandonments > 1 ? '#1890ff' : '#52c41a',
                                  color: 'white',
                                  padding: '4px 8px',
                                  borderRadius: '12px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  minWidth: '30px',
                                  display: 'inline-block'
                                }}>
                                  {abandonments}
                                </span>
                              </div>
                            ),
                            sorter: (a, b) => a.abandoned_on_page - b.abandoned_on_page,
                            sortOrder: pageAnalysisSorts.columnKey === 'abandoned_on_page' ? pageAnalysisSorts.order : null,
                            width: 140,
                          },
                          {
                            title: "Abandonment Rate",
                            dataIndex: 'abandonment_rate_percentage',
                            key: 'abandonment_rate_percentage',
                            render: (rate) => {
                              const percentage = parseFloat(rate) || 0;
                              const color = percentage >= 80 ? '#ff4d4f' : percentage >= 60 ? '#faad14' : percentage >= 40 ? '#1890ff' : '#52c41a';
                              
                              return (
                                <div style={{ textAlign: 'center' }}>
                                  <AnimatedProgressBar percentage={percentage} height="20px" showText={true} textColor="auto" />
                                </div>
                              );
                            },
                            sorter: (a, b) => a.abandonment_rate_percentage - b.abandonment_rate_percentage,
                            sortOrder: pageAnalysisSorts.columnKey === 'abandonment_rate_percentage' ? pageAnalysisSorts.order : null,
                            width: 160,
                          }
                        ]}
                        pagination={{
                          current: pageAnalysisPagination.current,
                          pageSize: pageAnalysisPagination.pageSize,
                          total: pageAnalysisPagination.total,
                          showSizeChanger: true,
                          showQuickJumper: true,
                          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} page abandonment points`,
                        }}
                      />
                    </div>
                  )}
                </div>

              </TabPane>
            </Tabs>
          )
        }
        {activeTab === 'contacts' && (
          <DetailedAnalysis 
            showFilters={false} 
            ref={detailedAnalysisRef}
            onDataLoaded={() => setContactsDataLoaded(true)}
          />
        )}
      </Card>
    </>
  );
}
